import { useContext } from 'react';
import { MainContext } from 'contexts/MainContext';

// ==============================|| CONFIG - HOOKS  ||============================== //

const useMain = () => useContext(MainContext);

export default useMain;
